import { http } from '../http'
import type { GroupBadges } from '@/types/badges'

/**
 * `GET /user/badges/{group}` — every menu badge of the group in one request
 * (it replaced five `.../count` calls per page change). Silent: it runs in
 * the background on navigation, and a failed refresh must not toast over
 * whatever page the user is reading.
 */
export function getBadges(groupId: number) {
  return http
    .get<GroupBadges>(`/user/badges/${groupId}`, { meta: { silent: true } })
    .then((response) => response.data)
}
